/* eslint-disable default-param-last */
import * as types from './types';

const initialState = {
  isLoading: false,
  buyBoxMatchedProperties: [],
  isFetchingBuyboxMatchedProperties: false,
  buyBoxPropertyMatch: null,
  buyBoxMatchedPropertyTotal: 0,
  isMatchingCountShown: false,
};
const BuyerReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case types.SET_LOADING:
    case types.SET_BUYBOX_MATCHED_PROPERTIES:
      return {
        ...state,
        ...payload,
        isCheckingBuyers: false,
        isGeneratingOffer: false,
      };
    case types.SET_MATCHING_COUNT_SHOWN:
      return {
        ...state,
        ...payload,
      };
    default:
      return state;
  }
};

export default BuyerReducer;
